import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

function normalizeToArray(value: string | string[] | undefined | null): string[] {
  if (value == null) return []
  if (Array.isArray(value)) return value
  return [String(value)]
}

export const useErrorStore = defineStore('errors', () => {
  const errors = ref<string[]>([])

  const getErrors = computed(() => errors.value ?? [])
  const hasErrors = computed(() => (errors.value ?? []).length > 0)

  /** Aceita: setErrors(errors) ou setErrors(prefix, errors) */
  function setErrors(p0: string | string[], newErrors?: string[] | string) {
    if (newErrors !== undefined) {
      errors.value = normalizeToArray(newErrors)
    } else {
      errors.value = normalizeToArray(p0)
    }
  }
  function clearErrors() {
    errors.value = []
  }
  function removeError(index: number) {
    const arr = errors.value ?? []
    arr.splice(index, 1)
    errors.value = arr
  }

  return { getErrors, hasErrors, setErrors, clearErrors, removeError }
})
